import { Breadcrumbs as MuiBreadcrumbs, styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const StyledBreadCrumbs = styled(MuiBreadcrumbs)(() => ({
  borderRadius: 4,
  marginBottom: 20,
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.blue.light,
  '&:hover': {
    color: theme.palette.blue.dark,
    textDecoration: 'underline',
  },
}));
